// pt-BR strings for the Plan 7 'shell' namespace (t('shell.…')), kept apart so each screen's strings live in one file.
export const shellPt = {
  nav: {
    atividades: 'Atividades',
    processos: 'Processos',
    territorio: 'Território',
    carteira: 'Carteira',
  },
  actNow_one: '{{count}} exige ação',
  actNow_other: '{{count}} exigem ação',
  search: {
    region: 'Consulta',
    label: 'Consultar',
    placeholder: 'Consultar: nº do processo, CPF/CNPJ ou nome do titular',
    submit: 'Pesquisar',
  },
  status: {
    link: 'Status das fontes',
    aria: 'Status das fontes: {{summary}}',
    ok: 'Fontes em dia',
    idle: 'Aguardando as fontes',
    warn: 'Fontes com atraso',
    crit: 'Fontes com falha',
  },
  account: {
    menu: 'Menu da conta',
    alertas: 'Alertas',
    equipe: 'Equipe',
    cobranca: 'Cobrança',
    consultor: 'Consultor',
    seguranca: 'Segurança',
    status: 'Status das fontes',
  },
} as const;
